<template>
  <el-main>
    <div class="mybread">
      <p><i class="el-icon-location"></i>当前位置：</p>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>个人事务管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/expense' }">报销管理</el-breadcrumb-item>
        <el-breadcrumb-item>报销申请</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="header">
      <div class="header-info">
        <h1>{{ userArr.realname }} {{ userArr.en_name }} </h1>
        <p style="font-size: 20px; font-weight: 550;"></p>
        <p>{{ userArr.department?.en_name }} - {{ userArr.role?.role_name }}</p>
        <p>直属领导：{{ userArr.leader_name }} {{ userArr.leader_en_name }} </p>
      </div>
    </div>

    <div class="form">
      <el-form ref="form" label-width="100px" label-position="left">
        <el-form-item label="报销总额：" prop="expense_amount">
          <el-col :span="3">
            <el-input placeholder="请输入" maxlength="100" v-model="form.expense_amount_from" clearable
              style="width: 100%;" @blur="expenseSearch" />
          </el-col>
          <el-col :span="1">
            <div style="width: 100%; text-align: center;"> — </div>
          </el-col>
          <el-col :span="3">
            <el-input placeholder="请输入" maxlength="100" v-model="form.expense_amount_to" clearable style="width: 100%;"
              @blur="expenseSearch" />
          </el-col>
        </el-form-item>

        <el-form-item label="更多" prop="type">
          <el-col :span="3" style="margin-right: 20px;">
            <el-select v-model="form.status" placeholder="报销状态" style="margin-right: 0; width: 100%;"
              @change="search(false)">
              <el-option label="待报销" value="0"></el-option>
              <el-option label="已申请报销" value="1"></el-option>
              <el-option label="无报销" value="2"></el-option>
            </el-select>
          </el-col>

          <el-col :span="3" style="margin-right: 20px;">
            <el-select v-model="form.leader_check_status" placeholder="主管审核状态" style="margin-right: 0; width: 100%;"
              @change="search(false)">
              <el-option label="待提交" value="0"></el-option>
              <el-option label="待审核" value="1"></el-option>
              <el-option label="审核通过" value="2"></el-option>
              <el-option label="审核不通过" value="3"></el-option>
            </el-select>
          </el-col>

          <el-col :span="3" style="margin-right: 20px;">
            <el-select v-model="form.finance_check_status" placeholder="财务审核状态" style="margin-right: 0; width: 100%;"
              @change="search(false)">
              <!-- <el-option label="待主管审核" value="0"></el-option> -->
              <el-option label="待审核" value="1"></el-option>
              <el-option label="审核通过" value="2"></el-option>
              <el-option label="审核不通过" value="3"></el-option>
            </el-select>
          </el-col>

          <el-col :span="3" style="margin-right: 20px;">
            <el-select v-model="form.pay_status" placeholder="支付状态" style="margin-right: 0; width: 100%;"
              @change="search(false)">
              <el-option label="未支付" value="1"></el-option>
              <el-option label="已支付" value="3"></el-option>
            </el-select>
          </el-col>

          <el-col :span="3" style="margin-right: 20px;">
            <el-select v-model="form.year" placeholder="选择年份" style="margin-right: 0; width: 100%;"
              @change="search(false)">
              <el-option :label="v" :value="v" v-for="(v, i) in yearList" :key="i"></el-option>
            </el-select>
          </el-col>

          <el-col :span="3">
            <el-select v-model="form.month" placeholder="选择月份" style="margin-right: 0; width: 100%;"
              @change="search(false)">
              <el-option :label="`${v}月`" :value="v" v-for="(v, i) in dd.month" :key="i"></el-option>
            </el-select>
          </el-col>
        </el-form-item>

        <el-form-item label="已选条件">
          <el-tag v-for="tag in tags" :key="tag.key" effect="dark" closable @close="removeTag(tag)">
            {{ tag.key }}: {{ tag.value }}
          </el-tag>
        </el-form-item>
      </el-form>
    </div>

    <div class="table">
      <div class="filterwrap">
        <div class="filter">
          <el-checkbox-group class="filtergroup" v-model="checkList" prop="checkList" :min="5">
            <el-checkbox label="报销说明"></el-checkbox>
            <el-checkbox label="报销年份"></el-checkbox>
            <el-checkbox label="报销月份"></el-checkbox>
            <el-checkbox label="报销总额"></el-checkbox>
            <el-checkbox label="业务报销金额"></el-checkbox>
            <el-checkbox label="日常报销金额"></el-checkbox>
            <el-checkbox label="已支付"></el-checkbox>
            <el-checkbox label="未支付"></el-checkbox>
            <el-checkbox label="报销状态"></el-checkbox>
            <el-checkbox label="主管审核状态"></el-checkbox>
            <el-checkbox label="财务审核状态"></el-checkbox>
            <el-checkbox label="支付状态"></el-checkbox>
            <el-checkbox label="申请人"></el-checkbox>
            <el-checkbox label="申请时间"></el-checkbox>
          </el-checkbox-group>
        </div>
        <div class="btnarea">
          <el-button @click="exportExpenseToExcel" v-if="NodeInclude('348')">导出数据</el-button>
          <el-button @click="addExShow = true" v-if="level == '1'">新增报销</el-button>
        </div>
      </div>

      <el-table :data="itemList" border stripe style="width: 100%;" highlight-current-row>
        <el-table-column prop="description" label="报销说明" header-align="center" align="center" min-width="300"
          v-if="check('报销说明')">
          <template slot-scope="scope">
            <div class="description">
              <div>{{ scope.row.description0 }}</div>
              <div>{{ scope.row.description1 }}</div>
              <div>{{ scope.row.description2 }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="expense_year" label="报销年份" header-align="center" align="center" min-width="120"
          v-if="check('报销年份')" />
        <el-table-column prop="expense_month" label="报销月份" header-align="center" align="center" min-width="80"
          v-if="check('报销月份')" />
        <el-table-column prop="expense_amount" label="报销总额" header-align="center" align="right" min-width="120"
          v-if="check('报销总额')" />
        <el-table-column prop="business_amount" label="业务报销金额" header-align="center" align="right" min-width="120"
          v-if="check('业务报销金额')" />
        <el-table-column prop="daily_amount" label="日常报销金额" header-align="center" align="right" min-width="120"
          v-if="check('日常报销金额')" />
        <el-table-column prop="pay_amount" label="已支付" header-align="center" align="right" min-width="120"
          v-if="check('已支付')" />
        <el-table-column prop="unpay_amount" label="未支付" header-align="center" align="right" min-width="120"
          v-if="check('未支付')" />
        <el-table-column prop="status" label="报销状态" header-align="center" align="center" min-width="120"
          v-if="check('报销状态')">
          <template slot-scope="scope">
            <div class="circle-tag" :style="{ 'background': dd.expense_status_c[scope.row.status].color }">
              <div class="word">{{ dd.expense_status_c[scope.row.status].word }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="主管审核状态" header-align="center" align="center" min-width="120"
          v-if="check('主管审核状态')">
          <template slot-scope="scope">
            <div class="circle-tag"
              :style="{ 'background': dd.leader_check_status_c[scope.row.leader_check_status].color }">
              <div class="word">{{ dd.leader_check_status_c[scope.row.leader_check_status].word }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="财务审核状态" header-align="center" align="center" min-width="120"
          v-if="check('财务审核状态')">
          <template slot-scope="scope">
            <div class="circle-tag"
              :style="{ 'background': dd.finance_check_status_c[scope.row.finance_check_status].color }">
              <div class="word">{{ dd.finance_check_status_c[scope.row.finance_check_status].word }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="pay_status" label="支付状态" header-align="center" align="center" min-width="120"
          v-if="check('支付状态')">
          <template slot-scope="scope">
            <div class="circle-tag" :style="{ 'background': dd.pay_status_c[scope.row.pay_status].color }">
              <div class="word">{{ dd.pay_status_c[scope.row.pay_status].word }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="staff" label="申请人" header-align="center" align="center" min-width="120"
          v-if="check('申请人')">
          <template slot-scope="scope">
            {{ scope.row.staff?.realname }}
          </template>
        </el-table-column>
        <el-table-column prop="application_time" label="申请时间" header-align="center" align="center" min-width="180"
          v-if="check('申请时间')" />
        <el-table-column prop="" label="操作" header-align="center" width="100" align="center" fixed="right" v-if=" NodeInclude('185') || NodeInclude('186')">
          <template slot-scope="scope">
            <div class="linkwrap">
              <el-link type='primary' class="link" @click="handleClick(scope.row)"
                v-if="(scope.row.judgetMent && (scope.row.user_id == userId) && scope.row.status != '2') && NodeInclude('185')">编辑</el-link>
              <el-link type='primary' class="link" @click="handleView(scope.row)" v-if="NodeInclude('186')">查看</el-link>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="expense" v-if="NodeInclude('187')">
        <div>报销总额合计：{{ total_expense_amount }}</div>
        <div>业务报销金额合计：{{ total_business_amount }}</div>
        <div>日常报销金额合计：{{ total_daily_amount }}</div>
      </div>
      <div class="apage">
        <el-pagination @current-change="handleCurrentChange" :current-page="p" :page-size="30"
          layout="total, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>

    <el-dialog title="新增报销" :visible.sync="addExShow" width="400px">
      <el-form ref="projectForm" :model="monthForm" label-width="150px" label-position="left">
				<el-form-item label="报销年份：">
					<el-col :span="6">
            <span>{{ yearList[this.yearList.length - 1] }}</span>
					</el-col>
				</el-form-item>
				<el-form-item label="选择报销月份:">
					<el-col :span="18">
            <el-select v-model="monthForm.month" placeholder="请选择月份" style="margin-right: 0; width: 100%;">
              <el-option :label="item" :value="item" v-for="(item, index) in monthList" :key="`m_${index}`"></el-option>
            </el-select>
					</el-col>
				</el-form-item>
				<el-form-item label="选择报销申请人：">
					<el-col :span="6">
            <span>{{ monthForm.realname }}</span>
					</el-col>
				</el-form-item>
			</el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addExShow = false">取 消</el-button>
        <el-button type="primary" @click="addExpenseFn">确 定</el-button>
      </span>
    </el-dialog>
  </el-main>
</template>

<script>
// CodeToText
import * as api from '@/api'
import { thousands } from '@/utils/index.js'
import store from '@/store'
export default {
  name: 'expense',
  data() {
    return {
      nodeLimtList: [],
      level: '',
      userId: '',
      id: '',
      checkList: [
        '报销说明',
        '报销年份',
        '报销月份',
        '报销总额',
        '业务报销金额',
        '日常报销金额',
        '已支付',
        '未支付',
        '报销状态',
        '主管审核状态',
        '财务审核状态',
        '支付状态',
        '申请人',
        '申请时间',
      ],
      yearList: [],
      itemList: [],
      total: 0,
      total_expense_amount: '0.00',
      total_business_amount: '0.00',
      total_daily_amount: '0.00',
      perPage: 30,
      p: 1,
      form: {
        key: '',
        atype: 'realname',
      },
      addExShow: false,
      monthList: [],
      monthForm: {
        year: new Date().getFullYear(),
        month: '',
        realname: '',
      },
      userArr: {},
    }
  },
  computed: {
    tags() {
      let temp = [
        {
          key: '报销总额',
          val: 'expense_amount',
          value: this.form.expense_amount_from + '-' + this.form.expense_amount_to,
          active: !!this.form.expense_amount_from && !!this.form.expense_amount_to,
        },
        {
          key: '报销状态',
          val: 'status',
          value: this.dd.expense_status[this.form.status],
          active: !!this.form.status,
        },
        {
          key: '主管审核状态',
          val: 'leader_check_status',
          value: this.dd.leader_check_status[this.form.leader_check_status],
          active: !!this.form.leader_check_status,
        },
        {
          key: '财务审核状态',
          val: 'finance_check_status',
          value: this.dd.finance_check_status[this.form.finance_check_status],
          active: !!this.form.finance_check_status,
        },
        {
          key: '支付状态',
          val: 'pay_status',
          value: this.dd.pay_status[this.form.pay_status],
          active: !!this.form.pay_status,
        },
        {
          key: '年份',
          val: 'year',
          value: `${this.form.year}年`,
          active: !!this.form.year,
        },
        {
          key: '月份',
          val: 'month',
          value: `${this.form.month}月`,
          active: !!this.form.month,
        },
      ]
      temp = temp.filter((item) => item.active)
      return temp
    },
  },
  created() {
    var date = new Date()
    var year = date.getFullYear() + 1
    this.getYearList(year);
    this.getStoreFn()
  },
  mounted() {
    this.getMonthFn()
  },
  methods: {
    checkUrlFn() {
      // 获取当前URL的哈希部分  
      const hash = window.location.hash;  
      // 移除'#'字符  
      const url = hash.substring(1); 
      
      let postData = {
        url_path: url
      }
      api.checkLoginUrl(postData).then((res) => {
        if (res.status == 400) {
          this.$message({
            type: 'info',
            message: '暂无权限',
          })
          this.$router.push({
            path: `/home`
          });
        }
      })
    },
    checkNodeFn(menu_id) {
      let postData = {
        menu_id,
      }
      api.checkNode(postData).then((res) => {
        this.nodeLimtList = res.node_ids.split(',')
      })
    },
    NodeInclude(val) {
      return this.nodeLimtList.includes(val)
    },
    exportExpenseToExcel() {
      window.location = api.exportExpenseToExcel({
        ...this.form,
        // [this.form.atype]: this.form.key,//搜索
      })
    },

    dateValue(dateArr) {
      if (Array.isArray(dateArr)) {
        return this.fdate(dateArr[0]) + '-' + this.fdate(dateArr[1])
      } else {
        return ''
      }
    },

    check(key) {
      return this.checkList.includes(key)
    },

    link(url) {
      this.$router.push(url)
    },

    getYearList(y) {
      for (let i = 2022; i < y; i++) {
        this.yearList.push(i)
      }
    },

    expenseSearch() {
      let from = parseInt(this.form.expense_amount_from)
      let to = parseInt(this.form.expense_amount_to)
      if (from > to && !isNaN(from) && !isNaN(to)) {
        this.form.expense_amount_to = from
        this.form.expense_amount_from = to
      }
      this.search()
    },

    getUserDetail(id) {
      return new Promise((resolve) => { 
        this.$fly.post('ApiStaffReimbursement_getStaffInfo.html', {
            uid: id,
          })
          .then((res) => {
            this.userArr = res
            console.log(this.userArr);
            resolve(res)
          })
      })
    },

    handleClick(item) {
      this.$router.push({
        path: '/expense/add',
        query: { id: item.id },
      })

    },

    handleView(item) {
      this.$router.push({
        path: '/expense/view',
        query: { id: item.id },
      })
    },

    search() {
      this.p = 1
      store.commit('setExpensePersonData', JSON.parse(JSON.stringify(this.form)))
      this.getList()
    },

    getStoreFn() {
      this.form = Object.keys(store.state.expensePersonData).length != 0 ? store.state.expensePersonData : this.form
      this.getList()
    },

    getMonthFn() {
      this.$fly
        .post('ApiStaffReimbursement_getReimMonth.html', {
          type: '4',
        })
        .then((res) => {
          this.monthList = res
        })
    },

    getList() {
      this.checkUrlFn()
      this.checkNodeFn('61')
      this.getUserDetail(this.query.id).then((res) => {
        this.form.realname = res.realname
        this.monthForm.realname = res.realname
        const postData = {
          ...this.form,
          p: this.p,
          per_page: this.perPage,
        }
        api.getPersonExpenseList(postData).then((res) => {
          this.itemList = res.itemList
          this.itemList = this.itemList.map((item) => {
            item.expense_year = item.expense_date.split('-')[0]
            item.expense_month = item.expense_date.split('-')[1]
            item.expense_amount = thousands(Number(item.expense_amount))
            item.business_amount = thousands(Number(item.business_amount))
            item.daily_amount = thousands(Number(item.daily_amount))
            item.pay_amount = thousands(Number(item.pay_amount))
            item.unpay_amount = thousands(Number(item.unpay_amount))
            item.judgetMent = this.judgetMent(item)
            item.description0 = item.description.split(' - ')[0]
            item.description1 = item.description.split(' - ')[1]
            item.description2 = item.description.split(' - ')[2]
            return item
          })
          this.total = +res.totalNum
          this.total_business_amount = thousands(Number(res.total_business_amount))
          this.total_daily_amount = thousands(Number(res.total_daily_amount))
          this.total_expense_amount = thousands(Number(res.total_expense_amount))
          setTimeout(() => {
            //权限
            this.level = store.state.level
            this.userId = store.state.userId
            console.log(this.level, this.userId);
          }, 200);
        })        
      })
    },
    removeTag(tag) {
      if (tag.val === 'expense_amount') {
        this.form.expense_amount_from = undefined
        this.form.expense_amount_to = undefined
      }
      !{
        type: () => {
          this.form['key'] = undefined
        },
      }[tag.val]?.()
      this.form[tag.val] = ''
      this.form.key = this.form.atype == '' ? '' : this.form.key
      store.commit('setExpensePersonData', JSON.parse(JSON.stringify(this.form)))
      this.getList()
      console.log(tag)
    },
    handleCurrentChange(p) {
      this.p = p
      store.commit('setExpensePersonData', JSON.parse(JSON.stringify(this.form)))
      this.getList()
    },
    judgetMent(obj) {
      if (obj.status == '0' || (obj.status == '1' && obj.leader_check_status == '3') || (obj.status == '1' && obj.leader_check_status == '2' && obj.finance_check_status == '3')) {
        return true //可编辑
      }
      else if (obj.status == '1' || (obj.status == '1' && obj.leader_check_status == '2') || (obj.status == '1' && obj.leader_check_status == '2' && obj.finance_check_status == '2')) {
        return false //不可编辑
      }
    },
    addExpenseFn() {
      this.$fly
        .post('ApiStaffReimbursement_createStaffReim', {
          ...this.monthForm
        })
        .then((res) => {
          if (res.status === 200) {
            this.$message.success(res.message)
            this.addExShow = false
          }
          // this.$router.go(-1)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.filterwrap {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0 0 20px 0;

  .filter {
    width: 85%;
  }

  .btnarea {
    box-sizing: border-box;
    width: 15%;
    padding: 0 20px;
    display: flex;
    justify-content: flex-end;
  }
}

.el-checkbox-group.filtergroup .el-checkbox {
  width: auto;
}

.apage {
  background: #f2f2f2;
  padding: 8px;
  text-align: right;
}

.el-select {
  margin-right: 20px;
}

.el-tag {
  margin-right: 20px;
  height: 36px;
  line-height: 36px;
  border: none;
}

.form {
  @extend %box;
  padding: 30px;
  margin-bottom: 20px;
}

.header {
  //标题样式
  @extend %box;
  box-sizing: border-box;
  width: 100%;
  background: #fff;
  padding: 20px 40px;
  margin-bottom: 10px;
  @extend %center;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: flex-start;

  .header-info {
    width: 80%;
    @extend %center;
    align-items: flex-start;
    text-align: left;

    h1 {
      font: 700 28px/1 $font;
      margin-bottom: 16px;
    }

    p {
      font: 16px/2 $font;
    }
  }

  .header-status {
    @extend %center;
    flex-flow: row nowrap;

    .button {
      box-sizing: border-box;
      min-width: 100px;
      border-radius: 20px;
      padding: 10px 15px;
      font: 12px/1 $font;
      color: #fff;
    }
  }
}

.table {
  @extend %box;
  padding: 30px;
}

.expense {
  @extend %start;
  padding: 30px 0;

  >div {
    margin-right: 30px;
  }
}

.linkwrap {
  font-size: 12px;

  &.normal {
    color: #606266;

    a {
      color: #606266;

      &:hover {
        &::after {
          height: 0.2px;
          background-color: #606266;
        }
      }

      >span {
        font-size: 12px;
        color: #606266;
      }
    }
  }
}

.description {
  @extend %start;

  div {
    &:nth-of-type(1) {
      width: 90px;
    }

    &:nth-of-type(2) {
      width: calc(100% - 150px);
    }

    &:nth-of-type(3) {
      width: 60px;
    }
  }
}
</style>
